/**
 * @fileoverview added by tsickle
 * Generated from: providers/request-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Subject } from 'rxjs';
import { parseParams } from '../util/http';
import { paginatedResponse } from '../util/paginated-response';
import * as serializers from '../util/serializers';
import { ApiUrlService } from './api-url-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './api-url-service';
import * as ɵngcc2 from '@angular/common/http';
export function SubscriptionResponse() { }
if (false) {
    /** @type {?} */
    SubscriptionResponse.prototype.endpoint;
    /** @type {?} */
    SubscriptionResponse.prototype.json;
    /** @type {?} */
    SubscriptionResponse.prototype.opts;
}
/**
 * @record
 */
export function ErrorResponse() { }
if (false) {
    /** @type {?} */
    ErrorResponse.prototype.endpoint;
    /** @type {?} */
    ErrorResponse.prototype.opts;
    /** @type {?} */
    ErrorResponse.prototype.error;
}
/**
 * Service to provide common HTTP request functions.
 */
var RequestService = /** @class */ (function () {
    function RequestService(apiUrlService, http) {
        this.apiUrlService = apiUrlService;
        this.http = http;
        this._subscribeSubject = new Subject();
        this._errorSubject = new Subject();
        this._withCredentials = false;
    }
    /**
     * Set the getter to set the headers for each HTTP request.
     */
    /**
     * Set the getter to set the headers for each HTTP request.
     * @param {?} fn
     * @return {?}
     */
    RequestService.prototype.setHeadersGetter = /**
     * Set the getter to set the headers for each HTTP request.
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._headersGetter = fn;
    };
    /**
     * @param {?} withCredentials
     * @return {?}
     */
    RequestService.prototype.setWithCredentials = /**
     * @param {?} withCredentials
     * @return {?}
     */
    function (withCredentials) {
        this._withCredentials = withCredentials;
    };
    /**
     * Retrieve the given endpoint's data from the server.
     * In most cases, the getInstance() and getList() methods should be used.
     */
    /**
     * Retrieve the given endpoint's data from the server.
     * In most cases, the getInstance() and getList() methods should be used.
     * @param {?} endpoint
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.get = /**
     * Retrieve the given endpoint's data from the server.
     * In most cases, the getInstance() and getList() methods should be used.
     * @param {?} endpoint
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        return this._getRequest(endpoint, opts).then((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return _this._handleResponse(response, opts); }));
    };
    /**
     * Helper method to retrieve a single instance.
     */
    /**
     * Helper method to retrieve a single instance.
     * @template T
     * @param {?} endpoint
     * @param {?} serializer
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.getInstance = /**
     * Helper method to retrieve a single instance.
     * @template T
     * @param {?} endpoint
     * @param {?} serializer
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, serializer, opts) {
        if (opts === void 0) { opts = {}; }
        opts.serializer = serializer;
        return this.get(endpoint, opts);
    };
    /**
     * Helper method to retrieve a list of instances.
     */
    /**
     * Helper method to retrieve a list of instances.
     * @template T
     * @param {?} endpoint
     * @param {?} serializer
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.getList = /**
     * Helper method to retrieve a list of instances.
     * @template T
     * @param {?} endpoint
     * @param {?} serializer
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, serializer, opts) {
        if (opts === void 0) { opts = {}; }
        /** @type {?} */
        var serializerKwargs = opts.serializerKwargs || {};
        serializerKwargs.many = true;
        opts.serializer = serializer;
        opts.serializerKwargs = serializerKwargs;
        return this.get(endpoint, opts);
    };
    /**
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.patch = /**
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, data, opts) {
        return this._updateRequest('patch', endpoint, data, opts);
    };
    /**
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.post = /**
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, data, opts) {
        return this._updateRequest('post', endpoint, data, opts);
    };
    /**
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.put = /**
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, data, opts) {
        return this._updateRequest('put', endpoint, data, opts);
    };
    /**
     * Perform a HTTP DELETE request.
     * If data is provided, the request content type is also changed to JSON.
     */
    /**
     * Perform a HTTP DELETE request.
     * If data is provided, the request content type is also changed to JSON.
     * @param {?} endpoint
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype.delete = /**
     * Perform a HTTP DELETE request.
     * If data is provided, the request content type is also changed to JSON.
     * @param {?} endpoint
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, opts) {
        if (opts === void 0) { opts = {}; }
        opts.headers = this._getRequestHeaders();
        return this.http.delete(this.apiUrlService.normaliseUrl(endpoint), opts).toPromise();
    };
    /**
     * Query the server and expect a paginated response.
     * The paginated response instance is responsible for serializing results,
     * and provides methods to return additional pages.
     */
    /**
     * Query the server and expect a paginated response.
     * The paginated response instance is responsible for serializing results,
     * and provides methods to return additional pages.
     * @param {?} endpoint
     * @param {?} opts
     * @param {?=} pageNumber
     * @return {?}
     */
    RequestService.prototype.getPage = /**
     * Query the server and expect a paginated response.
     * The paginated response instance is responsible for serializing results,
     * and provides methods to return additional pages.
     * @param {?} endpoint
     * @param {?} opts
     * @param {?=} pageNumber
     * @return {?}
     */
    function (endpoint, opts, pageNumber) {
        var _this = this;
        var serializer = opts.serializer, _a = opts.serializerKwargs, serializerKwargs = _a === void 0 ? {} : _a;
        serializerKwargs.many = true;
        if (pageNumber) {
            opts.params = Object.assign(opts.params || {}, { page: pageNumber });
        }
        return this._getRequest(endpoint, opts).then((/**
         * @param {?} json
         * @return {?}
         */
        function (json) {
            return paginatedResponse.create({
                requestFn: _this.getPage.bind(_this, endpoint, opts),
                json: json,
                serializer: serializer,
                serializerKwargs: serializerKwargs
            });
        }));
    };
    /**
     * Subscribe to HTTP GET responses
     */
    /**
     * Subscribe to HTTP GET responses
     * @param {?} fn
     * @return {?}
     */
    RequestService.prototype.subscribe = /**
     * Subscribe to HTTP GET responses
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        return this._subscribeSubject.subscribe(fn);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequestService.prototype.subscribeErrors = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        return this._errorSubject.subscribe(fn);
    };
    /**
     * Handle a single request.
     */
    /**
     * Handle a single request.
     * @private
     * @param {?} endpoint
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype._getRequest = /**
     * Handle a single request.
     * @private
     * @param {?} endpoint
     * @param {?=} opts
     * @return {?}
     */
    function (endpoint, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        /** @type {?} */
        var url = this.apiUrlService.normaliseUrl(endpoint);
        var params = opts.params, paramsSerializer = opts.paramsSerializer, noTransform = opts.noTransform;
        /** @type {?} */
        var optionsArgs = {
            headers: this._getRequestHeaders(),
            params: parseParams({ params: params, paramsSerializer: paramsSerializer, noTransform: noTransform }),
            withCredentials: this._withCredentials
        };
        /** @type {?} */
        var request;
        request = this.http.get(url, optionsArgs);
        if (opts.timeout) {
            request = request.timeout(opts.timeout);
        }
        return request
            .toPromise()
            .then((/**
         * @param {?} json
         * @return {?}
         */
        function (json) {
            _this._subscribeSubject.next({ endpoint: endpoint, json: json, opts: opts });
            return json;
        }))
            .catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this._errorSubject.next({ endpoint: endpoint, opts: opts, error: error });
            throw error;
        }));
    };
    /**
     * Helper method to post/put/patch data to the server.
     */
    /**
     * Helper method to post/put/patch data to the server.
     * @private
     * @param {?} method
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype._updateRequest = /**
     * Helper method to post/put/patch data to the server.
     * @private
     * @param {?} method
     * @param {?} endpoint
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    function (method, endpoint, data, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        /** @type {?} */
        var url = this.apiUrlService.normaliseUrl(endpoint);
        /** @type {?} */
        var requestSerializer = opts.requestSerializer || opts.serializer;
        /** @type {?} */
        var serializerKwargs = opts.serializerKwargs || {};
        var params = opts.params, paramsSerializer = opts.paramsSerializer, noTransform = opts.noTransform;
        /** @type {?} */
        var optionsArgs = {
            headers: this._getRequestHeaders(),
            params: parseParams({ params: params, paramsSerializer: paramsSerializer, noTransform: noTransform }),
            withCredentials: this._withCredentials
        };
        /** @type {?} */
        var serialized;
        if (noTransform) {
            serialized = data;
        }
        else if (requestSerializer) {
            serialized = requestSerializer.serialize(data, serializerKwargs);
        }
        else if (data) {
            serialized = serializers.serializer.serialize(data, serializerKwargs);
        }
        return this.http[method](url, serialized, optionsArgs)
            .toPromise()
            .then((/**
         * @param {?} json
         * @return {?}
         */
        function (json) { return _this._handleResponse(json, opts); }));
    };
    /**
     * @private
     * @return {?}
     */
    RequestService.prototype._getRequestHeaders = /**
     * @private
     * @return {?}
     */
    function () {
        if (this._headersGetter) {
            return this._headersGetter();
        }
        else {
            return new HttpHeaders();
        }
    };
    /**
     * Handle a server response.
     * If a serializer is provided, use that to deserialize the response.
     * Otherwise, perform basic transformations on the data (camelCase keys).
     */
    /**
     * Handle a server response.
     * If a serializer is provided, use that to deserialize the response.
     * Otherwise, perform basic transformations on the data (camelCase keys).
     * @private
     * @param {?} json
     * @param {?=} opts
     * @return {?}
     */
    RequestService.prototype._handleResponse = /**
     * Handle a server response.
     * If a serializer is provided, use that to deserialize the response.
     * Otherwise, perform basic transformations on the data (camelCase keys).
     * @private
     * @param {?} json
     * @param {?=} opts
     * @return {?}
     */
    function (json, opts) {
        if (opts === void 0) { opts = {}; }
        /** @type {?} */
        var responseSerializer = opts.responseSerializer || opts.serializer;
        if (responseSerializer) {
            return responseSerializer.deserialize(json, opts.serializerKwargs);
        }
        else if (!opts.noTransform && json) {
            return serializers.serializer.deserialize(json, opts.serializerKwargs);
        }
        else {
            return json;
        }
    };
    /** @nocollapse */
    RequestService.ctorParameters = function () { return [
        { type: ApiUrlService },
        { type: HttpClient }
    ]; };
RequestService.ɵfac = function RequestService_Factory(t) { return new (t || RequestService)(ɵngcc0.ɵɵinject(ɵngcc1.ApiUrlService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
RequestService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RequestService, factory: function (t) { return RequestService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RequestService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.ApiUrlService }, { type: ɵngcc2.HttpClient }]; }, null); })();
    return RequestService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    RequestService.prototype._subscribeSubject;
    /**
     * @type {?}
     * @private
     */
    RequestService.prototype._errorSubject;
    /**
     * @type {?}
     * @private
     */
    RequestService.prototype._headersGetter;
    /**
     * @type {?}
     * @private
     */
    RequestService.prototype._withCredentials;
    /**
     * @type {?}
     * @private
     */
    RequestService.prototype.apiUrlService;
    /**
     * @type {?}
     * @private
     */
    RequestService.prototype.http;
}
export { RequestService };

